import Resource from '@/api/resources/Resource'

class IncidentSeverityServices extends Resource {
    async getSeverities(laboratoryId) {
        const response = await this.axios.get(`/incident/laboratories/${laboratoryId}/severities`)
        loadedSeverities = response.data.reduce((map, obj) => {
            map[obj.id] = obj
            return map
        }, {})
        return response.data
    }
}

export default new IncidentSeverityServices()
export let loadedSeverities = []
